<template>
  <div class="wrapper-full" style="position: absolute" id="capture">
    <PhotoPreview
      v-if="isPhotoPreviewVisible"
      :isVisible="isPhotoPreviewVisible"
      :isOKBtnVisible="isPreviewOKBtnvisible"
      :upDown="upDown"
      :src="previewSrc"
      @hide-dialog="hidePreview"
    ></PhotoPreview>
    <PupilCorneaPreviewVue
      v-if="isPupilCorneaPreviewVisible"
      :isVisible="isPupilCorneaPreviewVisible"
      :isPupilOKBtnVisible="isPupilCorneaPreviewOKBtnvisible"
      :upDown="upDown"
      @hide-dialog="hidePupilCorneaPreview"
      :record="record"
      :pupilCorneaState="pupilCorneaState"
      :eyeType="eyeType"
    ></PupilCorneaPreviewVue>
    <el-container>
      <el-main :style="`height:${dispH}px;position:relative;`">
        <div class="eyetype-symbol" :style="symbolStyle" v-html="symbolContent"></div>
        <div v-if="videoTipVisible" class="eyetype-symbol" :style="recordingSymbolStyle">
          <i class="iconfont icon-record1"></i>
        </div>
        <!-- <div v-if="isTopography" class="eyetype-symbol" :style="ctOffsetStyle">
          <span :style="`color:${ctOffsetStr.x.color}`">
            Offset X:&nbsp;{{ ctOffsetStr.x.label }}
          </span>
          <br />
          <span :style="`color:${ctOffsetStr.y.color}`">
            Offset Y:&nbsp;{{ ctOffsetStr.y.label }}
          </span>
          <br />
          <span :style="`color:${ctOffsetStr.z.color}`">
            Offset Z:&nbsp;{{ ctOffsetStr.z.label }}
          </span>
        </div> -->
        <div class="eyetype-symbol" :style="lampStyle">
          <lamp-settings
            class="form-text"
            :currentMode="currentModeKey"
            :showTitle="false"
            :showSplit="false"
            :simple="true"
            @change="setCaptureMode"
          ></lamp-settings>
        </div>
        <canvas
          id="camDisplay"
          :width="videoSize.width"
          :height="videoSize.height"
          class="cam-window black btn-z-index"
          :style="previewStyle"
          @wheel="zoomPreview"
        ></canvas>
        <canvas
          id="indicatrixDrawer"
          class="cam-window btn-z-index"
          :width="videoSize.width"
          :height="videoSize.height"
          :style="previewStyle1"
          @wheel="zoomPreview"
        ></canvas>
      </el-main>
      <el-aside
        width="400px"
        style="border-left: 1px solid gray; padding-left: 20px; padding-bottom: 200px"
      >
        <!-- <el-button
          style="width: 200px; height: 50px; border: 1px solid gray"
          @click="openCam"
          >open</el-button
        >
        <el-button
          style="width: 200px; height: 50px; border: 1px solid gray"
          @click="closeCam"
          >close</el-button
        > -->
        <div class="capture-aside" v-show="!isHasUrl">
          <!-- <div v-if="isPupilCorneaVisible">
            <el-radio-group v-model="pupilCorneaInCaputre" text-color="#00ff00">
              <el-radio label="pupildia" text-color="#00ff00">{{
                $t('langcfg.txtPupil')
              }}</el-radio>
              <el-radio label="corneadia" text-color="#00ff00">{{
                $t('langcfg.txtCornea')
              }}</el-radio>
            </el-radio-group>
          </div>-->
          <div v-if="isPupilCorneaVisible && isNewInfrared" style="width: 100%">
            <div style="display: flex; width: 100%">
              <div style="font-size: 30px; width: 20%; margin-top: 5px">
                <span>{{ $t("langcfg.txtStatic1") }}:</span>
              </div>
              <div style="width: 80%">
                <div style="display: flex">
                  <el-button
                    ref="dark"
                    class="pupil-btn border-normal"
                    :class="{ 'pupilType-highlight': currPupilType === 'dark' }"
                    @click="setPupilType('dark')"
                  >
                    <span>{{ $t("langcfg.txtpupilcorneaDark") }}</span>
                  </el-button>
                  <div
                    :class="`pupil-complete-${pupilComplete.pupilcorneadia_dark}`"
                    style="line-height: 50px; font-size: 28px; margin-left: 5px"
                  ></div>
                </div>
                <div style="display: flex">
                  <el-button
                    ref="lowerMiddle"
                    class="pupil-btn border-normal"
                    :class="{ 'pupilType-highlight': currPupilType === 'lowerMiddle' }"
                    @click="setPupilType('lowerMiddle')"
                  >
                    <span>{{ $t("langcfg.txtpupilcorneaLowerMiddle") }}</span>
                  </el-button>
                  <div
                    :class="`pupil-complete-${pupilComplete.pupilcorneadia_lowerMiddle}`"
                    style="line-height: 50px; font-size: 28px; margin-left: 5px"
                  ></div>
                </div>
                <div style="display: flex">
                  <el-button
                    ref="middle"
                    class="pupil-btn border-normal"
                    :class="{ 'pupilType-highlight': currPupilType === 'middle' }"
                    @click="setPupilType('middle')"
                  >
                    <span>{{ $t("langcfg.txtpupilcorneaMiddle") }}</span>
                  </el-button>
                  <div
                    :class="`pupil-complete-${pupilComplete.pupilcorneadia_middle}`"
                    style="line-height: 50px; font-size: 28px; margin-left: 5px"
                  ></div>
                </div>
                <div style="display: flex">
                  <el-button
                    ref="bright"
                    class="pupil-btn border-normal"
                    :class="{ 'pupilType-highlight': currPupilType === 'bright' }"
                    @click="setPupilType('bright')"
                  >
                    <span>{{ $t("langcfg.txtpupilcorneaBright") }}</span>
                  </el-button>
                  <div
                    :class="`pupil-complete-${pupilComplete.pupilcorneadia_bright}`"
                    style="line-height: 50px; font-size: 28px; margin-left: 5px"
                  ></div>
                </div>
              </div>
            </div>
            <div style="display: flex; width: 100%">
              <div style="font-size: 30px; width: 20%; margin-top: 5px">
                <span>{{ $t("langcfg.txtDynamic") }}:</span>
              </div>
              <div style="width: 80%">
                <div style="display: flex">
                  <el-button
                    ref="dynamic"
                    class="pupil-btn border-normal"
                    :class="{ 'pupilType-highlight': currPupilType === 'dynamic' }"
                    @click="setPupilType('dynamic')"
                  >
                    <span>{{ $t("langcfg.txtpupilcorneaDynamic") }}</span>
                  </el-button>
                  <div
                    :class="`pupil-complete-${pupilComplete.pupilcorneadia_dynamic}`"
                    style="line-height: 50px; font-size: 28px; margin-left: 5px"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isTopographyVisible">
            <el-radio-group v-model="shotMode" text-color="#00ff00" style="margin-left: -20px">
              <el-radio label="far" text-color="#00ff00" @change="selectItem">
                {{ $t("langcfg.txtFar") }}
              </el-radio>
              <el-radio label="near" text-color="#00ff00" @change="selectItem">{{
                $t("langcfg.txtNear")
              }}</el-radio>
            </el-radio-group>
          </div>
          <div class="aside-content">
            <LiftControl />
          </div>
          <div v-if="isUpDownVisible">
            <el-radio-group v-model="upDownInCapture" text-color="#00ff00">
              <el-radio label="up" text-color="#00ff00" v-if="isUpRadioVisible && isUpOK">{{
                $t("langcfg.txtUp")
              }}</el-radio>
              <el-radio label="down" text-color="#00ff00" v-if="isDownRadioVisible && isDownOK">{{
                $t("langcfg.txtDown")
              }}</el-radio>
            </el-radio-group>
          </div>
          <split-h class="split-h" :splitH="10"></split-h>
          <el-checkbox v-if="isTopography" v-model="ctAutoShot" @change="ctAutoShotChanged">{{
            $t("langcfg.txtAutoShot")
          }}</el-checkbox>
          <split-h class="split-h" :splitH="2"></split-h>
          <el-checkbox v-if="isTopography" v-model="ctAutoUpDown" @change="ctAutoUpDownChanged">{{
            $t("langcfg.txtAutoUpDown")
          }}</el-checkbox>
          <split-h class="split-h" :splitH="10"></split-h>
          <div>
            <span style="font-size: 30px">{{ $t("langcfg.txtCapture") }}:</span>
          </div>
          <split-h class="split-h" :splitH="10"></split-h>
          <div class="btn-z-index">
            <el-button
              :class="`btn-oprator ${captureClass}`"
              style="width: 90%"
              @click="takePhotoVideo"
            >
              <i :class="btnIcon" style="font-size: 138px"> </i>
            </el-button>
            <div v-if="isTopographyVisible && currEyeType === 1" class="div-moduleeye">m</div>
          </div>
          <div v-if="isUpDownVisible"></div>
        </div>
      </el-aside>
    </el-container>
    <dryEyeTips
      class="warningClass"
      v-if="!isTopography"
      :curNibutStatusProp="curNibutStatus"
      :willChangeTipsProp="willChangeTips"
      @change-audioSrc="changeAudioSrcAndPlay"
      :modeProp="mode"
      :style="`${isDE ? 'bottom: 195px;' : 'bottom: 165px;'}`"
    />
    <!-- 拍摄提示语 -->
    <audio ref="audioRef" :src="audioSrc" hidden="true" />
    <div v-if="isRecording" class="video-mask"></div>
    <!-- 拍摄次数提示 -->
    <div class="numofshotsClass" v-if="mode === 'fbut' ? numberOfShotsStatus : false">
      {{ $t("langcfg.txtFbutShootThreeTimes") }} : {{ currentNumberOfShots }}
    </div>
  </div>
</template>
<script>
import * as recordHandle from "../../services/record";
import { uploadFiles, insertMediaFile } from "../../services/media";
import { Size, Message } from "../../mixins";
import { DRYEYEMODES, PAGES, TOPOGRAPHYMODES, TOPOGRAPHYCAMPTUREMODES } from "../../shared/consts";
import {
  getObjectLength,
  getSystemTime,
  isDefined,
  isFunction,
  logStdout,
  objectCopy
} from "../../shared/utils";
import GLRenderer from "../js/GLRenderer";
import LiftControl from "./LiftControl";
import UpDownSelector from "./UpDownSelector";
import PreviewIndicatrix from "../js/PreviewIndicatrix";
import DrawCTCal from "../js/DrawCTCal";
import PhotoPreview from "./PhotoPreview";
import PupilCorneaPreviewVue from "./PupilCorneaPreview.vue";
import fileSys from "../../fileoprators/fileSystem";
import { saveCaptureSettings, saveShotInfo } from "../../settings";
import EVENTS from "../../bus";
import { mapGetters, mapState } from "vuex";
import home from "../../store/modules/home";
import { getOffsetShown, getCTCenterOffsetInfo } from "../../topography/js/CalCenter";
import LampSettings from "./settings/LampSettings";
import dryEyeTips from "./dryEyeTips";
let captureState = "end";
let previewIndicatrix;
let centerpos = {
  x: 512,
  y: 384
};
let glRenderer; // = new GLRenderer()
let canvasDraw;
let camDisplay;
let timeoutCloseLamps;
const ASIDEWIDTH = 400;
let nibutInterval;
let nibutAutoStatus = 0;
let NIBUTSTATUS = {
  focus: { key: "focus", completed: false },
  firstBlinking: { key: "firstBlinking", completed: false, src: "" },
  secondBlinking: { key: "secondBlinking", completed: false, src: "" },
  startCam: { key: "startCam", completed: false, src: "" },
  keep: { key: "keep", completed: false, src: "" },
  end: { key: "end", completed: false, src: "" }
};
let autoCnt = 0;
let timeoutFirstBlink;
let timeoutSecondBlink;
let timeoutKeepBlink;
let intervalFirstBlink;
let intervalSecondBlink;
let IntervalButManual;
let intervalkeep;
let timeoutFocus;
let saveAudioSrc;
let timeoutCameraReady;
function getRecordTime(seconds) {
  let hour = parseInt(seconds / 3600);
  let min = seconds - hour * 3600;
  min = parseInt(min / 60);
  let second = seconds - hour * 3600 - min * 60;
  return `${pad2(min)}:${pad2(second)}`;
}
function pad2(v) {
  let _v = v.toFixed(0);
  return _v.padStart(2, "0");
}
let timeVideoTip;
let _imagePath = "";
let _videoPath = "";
let _self;
let _timeoutFrame;
export default {
  name: "Capture",
  data() {
    return {
      isNewInfrared: window.isNewInfrared(),
      currentPupilData: null,
      // isUpDownVisible: false,
      // isTopographyVisible: false,
      // isTopography: false,
      // isUpRadioVisible: false,
      // isDownRadioVisible: false,
      // isUpOK: false,
      // isDownOK: false,
      // isDryEyeVisible: false,
      // isDryEye: false,
      // isDryEyeMode: false,
      isTakeVideoOpen: false,
      isTakeVideoClose: false,
      oldEyeType: "",
      pupilComplete: {
        pupilcorneadia_dark: "N",
        pupilcorneadia_bright: "N",
        pupilcorneadia_middle: "N",
        pupilcorneadia_lowerMiddle: "N",
        pupilcorneadia_dynamic: "N"
      },
      pupilCompleteCurrent: {
        OS: {
          pupilcorneadia_dark: "N",
          pupilcorneadia_bright: "N",
          pupilcorneadia_middle: "N",
          pupilcorneadia_lowerMiddle: "N",
          pupilcorneadia_dynamic: "N"
        },
        OD: {
          pupilcorneadia_dark: "N",
          pupilcorneadia_bright: "N",
          pupilcorneadia_middle: "N",
          pupilcorneadia_lowerMiddle: "N",
          pupilcorneadia_dynamic: "N"
        }
      },
      currPupilType: "dark",
      eyeType: "",
      recordTime: "00:00",
      recordSeconds: 0,
      videoZoom: 1,
      isRecording: false,
      videoSize: {
        width: 1024,
        height: 768
      },
      isPreviewOKBtnvisible: true,
      // isPupilCorneaPreviewOKBtnvisible: true,
      isVideoTipVisible: false,
      upDownInCapture: "up",
      record: {},
      isCaptureFinished: true,
      isPhotoPreviewVisible: false,
      isPupilCorneaPreviewVisible: false,
      mediaFiles: {},
      previewSrc: "",
      PupilCorneaPreviewSrc: "",
      pupilCorneaInCaputre: "pupildia",
      ctXYPos: null,
      ctZPos: null,
      ctCanShot: false,
      ctCanShotFirst: null,
      canShotTimeMS: 0,
      shotMode: "far",
      isCameraReady: false,
      centerPoint: null,
      ctAutoShot: true,
      ctAutoUpDown: true,
      ctCaledOffset: {},
      captureSettingTool: {
        lipidlayertime: window.captureSettings.lipidlayertime
      },
      willChangeTips: true,
      curNibutStatus: "",
      audioSrc: "",
      audioSrcSrc: "",
      currentShootingEye: "",
      currentNumberOfShots: 1,
      currentBurArr: [],
      videoPaths: [],
      imagePaths: [],
      nextState: false,
      numberOfShotsStatus: false,
      isUpOK: true,
      isDownOK: true,
      isDE: false,
      currEyeType: window.captureSettings.EyeMaterial,
      pupilCorneaState: "pupilcorneadia_dark",
      pupilMax: 0,
      maxValue: 100,
      interval: 500
    };
  },
  mixins: [Size, Message],
  components: {
    LiftControl,
    UpDownSelector,
    PhotoPreview,
    LampSettings,
    dryEyeTips,
    PupilCorneaPreviewVue
  },
  created() {
    if (this.camera) {
      this.camera.setProcessingData(false, "created");
    }
    _self = this;
    this.shotMode = window.ctShotInfo.shotMode;

    window.pupilCorneaState = "pupilcorneadia_dark";
    window.topographyState = window.ctShotInfo.shotMode;
    this.record = objectCopy(this.currentRecord);
    this.isDE = window.settings.language === "de";
    if (!window.pupilCorneaMode) window.pupilCorneaMode = "pupilcorneadia";
    // this.pupilCorneaState = window.pupilCorneaMode ? window.pupilCorneaMode : 'pupilcorneadia_dark'
  },
  mounted() {
    window.pupilCorneaSelect = undefined;
    captureState = "end";
    this.$emit("hide-waiting");
    if (!global.glRenderer) {
      global.glRenderer = new GLRenderer();
    }
    glRenderer = global.glRenderer;
    this.focusLanguage === "zh_CN" ? (this.willChangeTips = true) : (this.willChangeTips = false);
    this.upDownInCapture = this.upDown.indexOf("up") >= 0 ? "up" : "down";
    clearInterval(timeVideoTip);
    document.addEventListener("keydown", this.onkeydown);
    canvasDraw = document.getElementById("indicatrixDrawer");
    camDisplay = document.getElementById("camDisplay");
    this.initCamera();
    glRenderer.setZoom(0, 0, this.videoZoom);
    previewIndicatrix = new PreviewIndicatrix(canvasDraw, centerpos);
    this.ctAutoShot = window.ctShotInfo.isAutoShot;
    this.ctAutoUpDown = window.ctShotInfo.autoMove.updown;
    this.$nextTick(() => {
      if (this.checkType === PAGES.topography && this.mode !== "pupilcorneadia") {
        let x = parseFloat(window.calibSettings.CenterPoint.x);
        let y = parseFloat(window.calibSettings.CenterPoint.y);
        this.centerPoint = { x, y };
        // if (previewIndicatrix) { previewIndicatrix.clearDraw() }
        this.drawCT();
      } else {
        this.drawDE();
      }
    });
    if (window.__capture__.debug) {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    }
    this.nibutAutoFn();
    this.$bus.$on(EVENTS.fbutVideoTime, () => {
      this.numberOfShotsStatus = window.captureSettings.FBUTtime === 3;
    });
    this.$bus.$on(EVENTS.changeEyeMaterial, () => {
      this.updateEyeMaterial();
    });
    if (isDefined(window.captureSettings.FBUTtime)) {
      this.numberOfShotsStatus = window.captureSettings.FBUTtime === 3;
    } else {
      this.numberOfShotsStatus = true;
    }
    if (this.mode === "fbut" || this.mode === "ocularsurface") {
      this.camera.startBuleLight();
    } else {
      this.camera.closeBuleLight();
    }
    this.$bus.$on("initCamera", (record) => {
      this.record = record;
      this.isCaptureFinished = true;
      // this.initCamera()
      this.isPreviewOKBtnvisible = false;
      this.isPhotoPreviewVisible = false;
      this.camera.setProcessingData(false, 4);
      captureState = "end";
      // this.initPupilComplete();
      this.isPupilCorneaPreviewVisible = true;
    });
    this.$bus.$on("initCam", (mode) => {
      // if (!mode.includes("pupilcorneadia")) {
      //   this.pupilCorneaState = "pupilcorneadia_dark";
      // }
      this.camera.setCaptureMode(mode, () => {
        this.setLaser(() => {
          this.setFilter(mode, () => {
            this.isCameraReady = true;
            clearTimeout(timeoutCameraReady);
            this.$bus.$emit(EVENTS.hideGlobalWatting);
          });
        });
      });
    });
    if (isDefined(window.captureSettings.testMaxValue)) {
      this.maxValue = window.captureSettings.testMaxValue;
      this.pupilMax = this.maxValue;
    } else {
      this.maxValue = 100;
      this.pupilMax = this.maxValue;
      window.captureSettings.testMaxValue = 100;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.captureSettings.testInterval)) {
      this.interval = window.captureSettings.testInterval;
    } else {
      this.interval = 500;
      window.captureSettings.testInterval = 500;
      saveCaptureSettings(window.captureSettings);
    }
  },
  updated() {
    this.isDE = window.settings.language === "de";
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    ...mapGetters(["camera"]),
    isPupilCorneaPreviewOKBtnvisible() {
      // pupilcorneadia_dark: "N",
      // pupilcorneadia_bright: "N",
      // pupilcorneadia_middle: "N",
      // pupilcorneadia_lowerMiddle: "N",
      // pupilcorneadia_dynamic: "N"
      if (this.pupilCorneaState === "pupilcorneadia_dark") {
        return (
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_bright === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_middle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_lowerMiddle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dynamic === "Y"
        );
      } else if (this.pupilCorneaState === "pupilcorneadia_bright") {
        return (
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dark === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_middle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_lowerMiddle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dynamic === "Y"
        );
      } else if (this.pupilCorneaState === "pupilcorneadia_middle") {
        return (
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dark === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_bright === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_lowerMiddle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dynamic === "Y"
        );
      } else if (this.pupilCorneaState === "pupilcorneadia_lowerMiddle") {
        return (
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dark === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_bright === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_middle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dynamic === "Y"
        );
      } else {
        return (
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_dark === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_bright === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_middle === "Y" &&
          this.pupilCompleteCurrent[`${this.eyeType}`].pupilcorneadia_lowerMiddle === "Y"
        );
      }
    },
    isUpRadioVisible() {
      return this.upDown.indexOf("up") >= 0;
    },
    isDownRadioVisible() {
      return this.upDown.indexOf("down") >= 0;
    },
    videoPhoto() {
      if (this.checkType === "questionnaire") {
        return this.checkType === PAGES.topography
          ? this.pupilCorneaState === "pupilcorneadia_dynamic"
            ? "video"
            : "photo"
          : DRYEYEMODES[this.mode].cam;
      } else {
        return this.checkType === PAGES.topography
          ? this.pupilCorneaState === "pupilcorneadia_dynamic"
            ? "video"
            : "photo"
          : DRYEYEMODES[this.mode].cam;
      }
    },
    modeLabel() {
      if (isDefined(DRYEYEMODES[this.mode])) {
        return this.$t(`langcfg.${DRYEYEMODES[this.mode].label}`);
      } else {
        return "";
      }
    },
    isUpDownVisible() {
      return (
        this.checkType === PAGES.dryeye &&
        (this.mode === DRYEYEMODES.eyelidedge.key || this.mode === DRYEYEMODES.meibomian.key)
      );
    },

    isPupilCorneaVisible() {
      return this.mode === TOPOGRAPHYMODES.pupilcorneadia.key;
    },
    isTopographyVisible() {
      return this.mode === PAGES.topography;
    },
    videoTipVisible() {
      return this.isRecording && this.isVideoTipVisible;
    },
    btnIcon() {
      return this.videoPhoto === "photo"
        ? `iconfont icon-camera`
        : `iconfont icon-video-fill ${this.recordingClass}`;
    },
    recordingClass() {
      return this.isRecording ? "color-recording" : "color-normal";
    },
    captureClass() {
      return this.isRecording ? "border-recording" : "border-normal";
    },
    symbolStyle() {
      return {
        left: `${this.videoSizePos.l + 5}px`,
        top: `${this.videoSizePos.t + 3}px`
      };
    },
    recordingSymbolStyle() {
      return {
        left: `${this.videoSizePos.l + this.videoSizePos.w - 40}px`,
        top: `${this.videoSizePos.t}px`,
        color: "red",
        fontSize: "50px;"
      };
    },
    ctOffsetStyle() {
      return {
        left: `${this.videoSizePos.l + this.videoSizePos.w - 300}px`,
        top: `${this.videoSizePos.t}px`,
        // color: '#f80',
        fontSize: "40px",
        textAlign: "left",
        width: "290px"
      };
    },
    lampStyle() {
      return {
        left: `${this.videoSizePos.l / 2 + this.videoSizePos.w / 2 - 150}px`,
        top: `${this.videoSizePos.t + 10}px`,
        color: "gray",
        fontSize: "30px",
        textAlign: "left",
        width: "420px"
      };
    },
    symbolContent() {
      let zoom =
        this.isTopography || this.isPupilCorneaVisible
          ? ""
          : "x" + this.videoZoom.toFixed(2) + "&nbsp;";
      return `${this.eyeType}&nbsp;${this.videoZoom > 1 ? zoom : ""}
       ${this.isRecording ? this.recordTime : ""}`;
    },
    videoSizePos() {
      let containerWidth = this.dispW - ASIDEWIDTH;
      let containerHeight = this.dispH;
      // console.log(this.dispW, this.dispH)
      let ratioW = containerWidth / this.videoSize.width;
      let ratioH = containerHeight / this.videoSize.height;
      let width = 1024;
      let height = 768;
      if (ratioW < ratioH) {
        width = containerWidth;
        height = this.videoSize.height * ratioW;
      } else {
        width = this.videoSize.width * ratioH;
        height = containerHeight;
      }
      return {
        w: width,
        h: height,
        l: (containerWidth - width) / 2,
        t: (containerHeight - height) / 2 + 2
      };
    },
    previewStyle1() {
      return {
        width: `${this.videoSizePos.w}px`,
        height: `${this.videoSizePos.h - 20}px`,
        left: `${this.videoSizePos.l}px`,
        top: `${this.videoSizePos.t}px`
      };
    },
    previewStyle() {
      return {
        width: `${this.videoSizePos.w}px`,
        height: `${this.videoSizePos.h - 20}px`,
        left: `${this.videoSizePos.l}px`,
        top: `${this.videoSizePos.t}px`,
        background: "#000"
      };
    },
    isTopography() {
      return this.mode === PAGES.topography;
    },
    ctOffsetStr() {
      return getOffsetShown(this.ctCaledOffset);
    },
    currentModeKey() {
      return this.getCaptureMode(this.mode);
    },
    currentModeLabel() {
      if (this.mode === PAGES.topography) {
        return (
          this.$t(`langcfg.txtTopography`) +
          "_" +
          (this.shotMode === "near" ? this.$t("langcfg.txtNear") : this.$t("langcfg.txtFar"))
        );
      } else {
        for (let name in DRYEYEMODES) {
          if (DRYEYEMODES[name].key === this.mode) {
            return this.$t(`langcfg.${DRYEYEMODES[name].label}`);
          }
        }

        for (let name in TOPOGRAPHYCAMPTUREMODES) {
          if (TOPOGRAPHYCAMPTUREMODES[name].key === this.mode) {
            return this.$t(`langcfg.${TOPOGRAPHYCAMPTUREMODES[name].label}`);
          }
        }
      }
      return "";
    },
    butModelComputed() {
      return this.$store.state.dryeye.windowBUTModel;
    },
    nibutModelComputed() {
      return this.$store.state.dryeye.windowNibutModel;
    }
  },
  methods: {
    initPupilComplete() {
      if (this.record && this.record.content) {
        // console.log(
        //   "---pupildebug initPupilComplete this.record.content2---",
        //   `data${this.eyeType}`
        // );
        if (this.record.content[`data${this.eyeType}`]["pupilcorneadia_dark"]) {
          this.pupilComplete.pupilcorneadia_dark = "Y";
        } else {
          this.pupilComplete.pupilcorneadia_dark = "N";
        }
        if (this.record.content[`data${this.eyeType}`]["pupilcorneadia_lowerMiddle"]) {
          this.pupilComplete.pupilcorneadia_lowerMiddle = "Y";
        } else {
          this.pupilComplete.pupilcorneadia_lowerMiddle = "N";
        }
        if (this.record.content[`data${this.eyeType}`]["pupilcorneadia_middle"]) {
          this.pupilComplete.pupilcorneadia_middle = "Y";
        } else {
          this.pupilComplete.pupilcorneadia_middle = "N";
        }
        if (this.record.content[`data${this.eyeType}`]["pupilcorneadia_bright"]) {
          this.pupilComplete.pupilcorneadia_bright = "Y";
        } else {
          this.pupilComplete.pupilcorneadia_bright = "N";
        }
        if (this.record.content[`data${this.eyeType}`]["pupilcorneadia_dynamic"]) {
          this.pupilComplete.pupilcorneadia_dynamic = "Y";
        } else {
          this.pupilComplete.pupilcorneadia_dynamic = "N";
        }

        if (this.pupilCompleteCurrent[`${this.eyeType}`]["pupilcorneadia_dark"] === "Y") {
          this.$refs["dark"].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
        } else {
          if (this.$refs["dark"]) {
            this.$refs["dark"].$el.style.backgroundColor = "transparent";
          }
        }

        if (this.pupilCompleteCurrent[`${this.eyeType}`]["pupilcorneadia_lowerMiddle"] === "Y") {
          this.$refs["lowerMiddle"].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
        } else {
          if (this.$refs["lowerMiddle"]) {
            this.$refs["lowerMiddle"].$el.style.backgroundColor = "transparent";
          }
        }

        if (this.pupilCompleteCurrent[`${this.eyeType}`]["pupilcorneadia_middle"] === "Y") {
          this.$refs["middle"].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
        } else {
          if (this.$refs["middle"]) {
            this.$refs["middle"].$el.style.backgroundColor = "transparent";
          }
        }

        if (this.pupilCompleteCurrent[`${this.eyeType}`]["pupilcorneadia_bright"] === "Y") {
          this.$refs["bright"].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
        } else {
          if (this.$refs["bright"]) {
            this.$refs["bright"].$el.style.backgroundColor = "transparent";
          }
        }

        if (this.pupilCompleteCurrent[`${this.eyeType}`]["pupilcorneadia_dynamic"] === "Y") {
          this.$refs["dynamic"].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
        } else {
          if (this.$refs["dynamic"]) {
            this.$refs["dynamic"].$el.style.backgroundColor = "transparent";
          }
        }
      }
    },
    setPupilType(type) {
      this.currPupilType = type;
      this.pupilCorneaState = `pupilcorneadia_${type}`;
      window.pupilCorneaState = `pupilcorneadia_${type}`;
    },
    openCam() {
      this.initCamera();
    },
    closeCam() {
      this.camera.closeCamera();
    },
    removeListener() {
      document.removeEventListener("keydown", this.onkeydown);
    },
    getCaptureMode() {
      let _mode;
      if (this.mode === PAGES.topography) {
        _mode = this.mode + `_${this.shotMode}`;
      } else if (this.mode === PAGES.pupilcorneadia) {
        // _mode = window.pupilCorneaMode === 'pupilcorneadia' ? 'pupilcorneadia' : `pupilcorneadia_${window.pupilCorneaMode}`
        _mode =
          this.currPupilType === "dynamic"
            ? "pupilcorneadia_dynamic"
            : `pupilcorneadia_${this.currPupilType}`;
      } else {
        _mode = this.mode;
      }
      return _mode;
      // return this.mode === PAGES.topography ? this.mode + `_${this.shotMode}` : this.mode
    },
    selectItem() {
      window.topographyState = this.shotMode;
      this.setCaptureMode();
    },
    selectPupilCornea(mode) {
      window.pupilCorneaMode = mode;
      let _mode = mode === "pupilcorneadia" ? mode : `pupilcorneadia_${mode}`;
      this.$bus.$emit("camInit");
      this.$bus.$emit("lampInit", _mode);
      this.setCaptureMode(_mode);
      this.$emit("select-subpage", "pupilcorneadia", mode);
    },
    setLaser(callback) {
      if (this.mode === PAGES.topography) {
        this.camera.setLaser(this.shotMode, () => {
          if (isFunction(callback)) callback();
        });
      } else {
        this.camera.closeLaser(() => {
          if (isFunction(callback)) callback();
        });
      }
    },
    setFilter(mode, callback) {
      this.camera.setFilter(mode, callback);
      window.ctShotInfo.shotMode = this.shotMode;
      saveShotInfo(window.ctShotInfo);
    },
    setCaptureMode() {
      // this.$bus.$emit(EVENTS.showGlobalWatting)
      let _mode = this.getCaptureMode(this.mode);

      if (!_mode.includes("pupilcorneadia")) {
        this.pupilCorneaState = "pupilcorneadia_dark";
        this.currPupilType = "dark";
      }
      if (!isDefined(this.camera) || window.__capture__.debug) {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
        return;
      }
      timeoutCameraReady = setTimeout(() => {
        this.isCameraReady = true;
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 3000);
      this.camera.setCaptureMode(_mode, () => {
        if (_mode === "fbut" || _mode === "ocularsurface") {
          this.camera.startBuleLight();
        } else {
          this.camera.closeBuleLight();
        }

        this.setLaser(() => {
          this.setFilter(_mode, () => {
            this.isCameraReady = true;
            clearTimeout(timeoutCameraReady);
            this.$bus.$emit(EVENTS.hideGlobalWatting);
          });
        });
      });
    },
    initCamera() {
      _self = this;
      // 该变量在cfg/capture.json里面设置
      if (!isDefined(window.captureSettings.isDrawNIBUT)) {
        window.captureSettings.isDrawNIBUT = 1;
        saveCaptureSettings(window.captureSettings);
      }
      if (!isDefined(window.captureSettings.isDrawBUT)) {
        window.captureSettings.isDrawBUT = 1;
        saveCaptureSettings(window.captureSettings);
      }
      if (!isDefined(window.captureSettings.SelectLight)) {
        window.captureSettings.SelectLight = true;
        saveCaptureSettings(window.captureSettings);
      }

      this.camera.setProcessingData(false, 1);
      this.camera.setFrameCallback(this.onFrame);
      if (!isDefined(glRenderer.glCtx) && isDefined(camDisplay)) {
        glRenderer.setupGL(camDisplay);
      }
      glRenderer.setZoom(0, 0, this.videoZoom);
      this.camera.on("frame-callback", (buf, w, h, time) => {
        // console.log("---frame callback time---", time);
        if (this.pupilCorneaState === "pupilcorneadia_dynamic") {
          if (time < 15000) {
            if (time >= 2000) {
              if (this.isTakeVideo) {
                this.isTakeVideo = false;
                this.camera.openWhiteLamp("pupilcorneadia_dynamic");
              }
            }
            if (time >= 4000) {
              if (this.isTakeVideoClose) {
                this.camera.closeWhiteLamp("pupilcorneadia_dynamic");
                this.isTakeVideoClose = false;
              }
            }
          }
        }
        _self.onFrame(buf, w, h);
        // _self.isFrameValid()
      });
      // _self.isFrameValid()
      _self.$bus.$on(EVENTS.eyeTypeShot, (eyetype, shot) => {
        if (captureState === "end") {
          _self.eyeType = eyetype;
          if (_self.oldEyeType !== eyetype) {
            _self.oldEyeType = eyetype;
            _self.initPupilComplete();
          }
        }
        if (shot) {
          if (_self.isCameraReady) {
            _self.onkeydown({
              code: "Space"
            });
          }
        }
        // this.initPupilComplete()
      });
      _self.setCaptureMode();
      // setTimeout(() => {
      //   this.isCameraReady = true
      //   if (window.__capture__.debug) {
      //     this.$bus.$emit(EVENTS.hideGlobalWatting)
      //   }
      // }, 1000)
    },
    // isFrameValid () {
    //   clearTimeout(_timeoutFrame)
    //   _timeoutFrame = setTimeout(() => {
    //     capture.closeCamera()
    //     fileSys.deleteFile(fileSys.getTmpFilePath('init.json'))
    //     fileSys.relaunch()
    //   }, 10000)
    // },
    onFrame(buf, w, h) {
      glRenderer.drawFrame(w, h, glRenderer.glCtx);
      if (_self.mode === PAGES.topography && this.mode !== "pupilcorneadia") {
        this.handleTopographyBuf(buf, w, h);
      }
    },
    doCtAutoShot(canShot) {
      if (canShot) {
        // 满足自动拍摄条件
        if (!this.ctCanShot || !this.ctCanShotFirst) {
          // 记下满足自动拍摄条件 起始状态
          this.ctCanShot = true;
          this.ctCanShotFirst = new Date().getTime();
        } else {
          // 满足自动拍摄条件后,持续300毫秒以上,才可以自动拍摄
          this.canShotTimeMS = new Date().getTime() - this.ctCanShotFirst;
          if (this.canShotTimeMS > window.ctShotInfo.autoShot.delay) {
            // this.isCaptureFinished = true
            this.takePhotoVideo();
          }
        }
      } else {
        // 不满足自动拍摄条件则清除变量值
        this.ctCanShot = false;
        this.canShotTimeMS = null;
      }
    },
    handleTopographyBuf(buf, w, h) {
      autoCnt++;
      // if (!capture) {
      //   return;
      // }
      if (autoCnt % 2 === 0) {
        let caledInfo = getCTCenterOffsetInfo(buf, w, h);
        this.ctXYPos = caledInfo.xyz.xypos;
        this.ctZPos = caledInfo.xyz.zpos;
        autoCnt = 0;
        this.ctCaledOffset = caledInfo.offsetxyz;
        this.drawCT();
        if (this.isCameraReady) {
          this.camera.autoCTUpDown(this.ctCaledOffset);
        }
        if (window.ctShotInfo.isAutoShot) {
          this.doCtAutoShot(caledInfo.inrange);
        }
      }
    },
    async onkeydown(e) {
      if (this.isPupilCorneaPreviewVisible) {
        if (this.isNewInfrared) {
          if (this.isPupilCorneaPreviewOKBtnvisible) {
            this.hidePupilCorneaPreview("end");
          } else {
            this.hidePupilCorneaPreview("OK");
          }
        } else {
          this.hidePupilCorneaPreview("end");
        }

        return;
      }
      this.removeListener();
      if (!isDefined(e) || !isDefined(_self)) return;
      if (e.preventDefault) e.preventDefault();
      if (e.code === "Space") {
        if (_self.isPhotoPreviewVisible) {
          _self.isPhotoPreviewVisible = false;
          _self.hidePreview(_self.isPreviewOKBtnvisible ? "OK" : "end");
        } else {
          if (this.curNibutStatus === "keep") {
            this.curNibutStatus = "end";
            this.changeAudioSrcAndPlay();
          }
          _self.takePhotoVideo();
        }
      }
      setTimeout(() => {
        document.addEventListener("keydown", this.onkeydown);
      }, 1000);
    },
    isPhoto() {
      return this.videoPhoto === "photo";
    },
    isVideo() {
      return this.videoPhoto === "video";
    },
    isUpDown() {
      return this.mode === DRYEYEMODES.eyelidedge.key || this.mode === DRYEYEMODES.meibomian.key;
    },
    hidePreview(op) {
      let key = this.upDownInCapture === "up" ? "imagePathUp" : "imagePathDown";
      switch (op) {
        case "OK":
          if (this.mode === "meibomian" || this.mode === "eyelidedge") {
            this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtProccessingData"));
            this.$bus.$emit(EVENTS.dryeyeUpDown, true);
            this.nextState = true;
          }
          this.$set(this.mediaFiles, key, _imagePath);
          this.upDownInCapture = this.upDownInCapture === "up" ? "down" : "up";
          this.isUpOK = this.upDownInCapture === "up";
          this.isDownOK = this.upDownInCapture === "down";
          this.$store.state.capture.hasUpImgPath = true;
          if (this.mode === "meibomian" || this.mode === "eyelidedge") {
            this.emitPhotoVideoFinished("take-photo-video-finished");
          }
          this.camera.setProcessingData(false, 2);
          setTimeout(() => {
            this.isCaptureFinished = true;
            this.isPhotoPreviewVisible = false;
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            document.addEventListener("keydown", this.onkeydown);
          }, 800);
          break;
        case "cancel":
          this.$store.state.capture.hasUpImgPath = false;
          this.isCaptureFinished = true;
          this.isPhotoPreviewVisible = false;
          document.addEventListener("keydown", this.onkeydown);
          this.camera.setProcessingData(false, 3);
          break;
        case "end":
          if (this.mode === "meibomian" || this.mode === "eyelidedge") {
            this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtProccessingData"));
            this.$bus.$emit(EVENTS.dryeyeUpDown, false);
            this.nextState = false;
            this.$set(
              this.mediaFiles,
              key === "imagePathDown" ? "imagePathUp" : "imagePathDown",
              null
            );
          }
          this.$set(this.mediaFiles, key, _imagePath);
          this.emitPhotoVideoFinished("take-photo-video-finished");
          this.$store.state.capture.hasUpImgPath = false;
          setTimeout(() => {
            this.isCaptureFinished = true;
            this.isPhotoPreviewVisible = false;
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            document.addEventListener("keydown", this.onkeydown);
          }, 2000);
          break;
        default:
          break;
      }
    },
    hidePupilCorneaPreview(mode) {
      this.isPupilCorneaPreviewVisible = false;
      switch (mode) {
        case "cancel":
          delete this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`];

          // console.log(
          //   "---hidePupilCorneaPreview this.record.content.dataOD.topograghy---",
          //   this.record.content.dataOD.topograghy
          // );

          if (this.currentPupilData) {
            this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`] = objectCopy(
              this.currentPupilData
            );
            fileSys.copyFile123(
              `/home/mw520/dea520/dist/media/${this.currentPupilData.photos[0].filename}`,
              "/home/mw520/dea520/dist/server/uploads/"
            );

            const fileInfo = {
              filename: this.currentPupilData.photos[0].filename,
              originalname: this.currentPupilData.photos[0].originalname,
              mimetype: this.currentPupilData.photos[0].mimetype,
              size: this.currentPupilData.photos[0].size,
              savedate: this.currentPupilData.photos[0].savedate,
              thumbnail: this.currentPupilData.photos[0].thumbnail,
              username: this.currentPupilData.photos[0].username,
              fieldname: this.currentPupilData.photos[0].fieldname
            };

            insertMediaFile(fileInfo, window.token)
              .then((res) => {})
              .catch((err) => {
                console.log("---insertMediaFile err---", err);
              });
            // uploadFiles([
            //   `/home/mw520/dea520/dist/media/${this.currentPupilData.photos[0].filename}`
            // ]);
          }
          if (
            this.record.content.dataOD.topography ||
            this.record.content.dataOS.topography ||
            this.record.content.dataOD.pupilcorneadia_dark ||
            this.record.content.dataOS.pupilcorneadia_dark ||
            this.record.content.dataOD.pupilcorneadia ||
            this.record.content.dataOS.pupilcorneadia ||
            this.record.content.dataOD.pupilcorneadia_lowerMiddle ||
            this.record.content.dataOS.pupilcorneadia_lowerMiddle ||
            this.record.content.dataOD.pupilcorneadia_middle ||
            this.record.content.dataOS.pupilcorneadia_middle ||
            this.record.content.dataOD.pupilcorneadia_bright ||
            this.record.content.dataOS.pupilcorneadia_bright ||
            this.record.content.dataOD.pupilcorneadia_dynamic ||
            this.record.content.dataOS.pupilcorneadia_dynamic
          ) {
            recordHandle.updateRecord(this.record, (res) => {
              this.$bus.$emit("CHANGECURRENTRECORD", this.record);
              this.initPupilComplete();
            });
          } else {
            recordHandle.deleteRecord(this.record._id, this.record, (res) => {
              this.$bus.$emit("CHANGECURRENTRECORD", null);
            });
          }
          break;
        case "OK":
          const pupilTypeOK = this.pupilCorneaState.split("_")[1];
          this.pupilCompleteCurrent[`${this.eyeType}`][`pupilcorneadia_${pupilTypeOK}`] = "Y";
          // this.$refs[`${pupilTypeOK}`].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
          this.initPupilComplete();
          let pupilType = "dark";
          if (pupilTypeOK === "dark") {
            pupilType = "lowerMiddle";
          } else if (pupilTypeOK === "lowerMiddle") {
            pupilType = "middle";
          } else if (pupilTypeOK === "middle") {
            pupilType = "bright";
          } else if (pupilTypeOK === "bright") {
            pupilType = "dynamic";
          } else if (pupilTypeOK === "dynamic") {
            pupilType = "dark";
          }
          this.setPupilType(pupilType);
          break;
        case "end":
          // const pupilTypeEnd = this.pupilCorneaState.split("_")[1];

          // this.$refs[`${pupilTypeEnd}`].$el.style.backgroundColor = "rgba(0, 255, 0, 0.637)";
          if (this.isNewInfrared) {
            const pupilTypeEnd = this.pupilCorneaState.split("_")[1];
            this.pupilCompleteCurrent[`${this.eyeType}`][`pupilcorneadia_${pupilTypeEnd}`] = "Y";
            this.initPupilComplete();
          } else {
            this.record.content[`data${this.eyeType}`][`pupilcorneadia`] = objectCopy(
              this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
            );

            delete this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`];

            let _eyetype = "---" + this.eyeType + "---";

            console.log("---cknb---", _eyetype);

            recordHandle.updateRecord(this.record, (res) => {
              this.$bus.$emit("ENTERRECORD", this.record, "pupilcorneadia", _eyetype.slice(3, 5));
            });
          }
          break;
        default:
          break;
      }

      if (this.currentPupilData) {
        fileSys.removeFile123(
          `/home/mw520/dea520/dist/media/${this.currentPupilData.photos[0].filename}`
        );
        this.currentPupilData = null;
      }
    },
    emitPhotoVideoFinished(e, data) {
      this.recordSeconds = 0;
      this.recordTime = "00:00";

      if (this.mode !== "tearheight" && !this.nextState) {
        timeoutCloseLamps = setTimeout(() => {
          if (this.mode !== "pupilcorneadia") {
            this.camera.closeAllLamps();
          }
        }, 500);
      }
      if (this.mediaFiles.videoPath && this.mediaFiles.videoPath.indexOf("_tmp") > -1) {
        this.mediaFiles.videoPath = this.mediaFiles.videoPath.replace("_tmp", "");
      }
      this.$emit(
        e,
        this.checkType,
        this.mode,
        this.mediaFiles,
        this.eyeType,
        data,
        this.pupilCorneaState,
        () => {
          this.camera.clearTempFiles(() => {
            this.isCaptureFinished = true;
            this.$emit("hide-waiting");
          });
        }
      );
      this.$bus.$emit(EVENTS.canLogout, true);
    },
    afterTakePhoto() {
      this.$bus.$emit(EVENTS.dryeyeUpDown, false);
      this.nextState = false;

      if (this.isUpDown()) {
        this.isPreviewOKBtnvisible =
          this.upDown.indexOf("up_down") < 0 ? false : getObjectLength(this.mediaFiles) < 1;
        captureState = "updown";
        setTimeout(() => {
          if (this.mode !== "pupilcorneadia") {
            this.isPhotoPreviewVisible = true;
          }
          document.addEventListener("keydown", this.onkeydown);
          this.$bus.$emit(EVENTS.hideGlobalWatting);
        }, 1000);
        return;
      }
      this.mediaFiles = {
        imagePath: _imagePath
      };
      this.$bus.$emit(EVENTS.canLogout, true);
      this.emitPhotoVideoFinished("take-photo-video-finished");
    },
    afterTakeVideo(data) {
      if (this.mode !== "pupilcorneadia") {
        this.$bus.$emit(EVENTS.dryeyeUpDown, false);
      }
      // this.$bus.$emit(EVENTS.dryeyeUpDown, false)
      this.nextState = false;
      if (this.mode === "fbut") {
        this.mediaFiles = {
          imagePath: this.imagePaths,
          videoPath: this.videoPaths
        };
      } else {
        this.mediaFiles = {
          imagePath: _imagePath,
          videoPath: _videoPath
        };
      }
      this.$bus.$emit(EVENTS.canLogout, true);
      this.emitPhotoVideoFinished("take-photo-video-finished", data);
    },
    async takePhotoVideo() {
      if (this.mode === "pupilcorneadia") {
        // console.log(
        //   "---currentPupilData 1111---",
        //   this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
        // );

        if (
          this.record &&
          this.record.content &&
          this.record.content[`data${this.eyeType}`] &&
          this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
        ) {
          console.log(
            "---hzx111---",
            this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
          );

          this.currentPupilData = objectCopy(
            this.record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
          );
          console.log(
            "---hzx111--- filename",
            `/home/mw520/dea520/dist/server/uploads/${this.currentPupilData.photos[0].filename}`
          );

          fileSys.copyFile123(
            `/home/mw520/dea520/dist/server/uploads/${this.currentPupilData.photos[0].filename}`,
            "/home/mw520/dea520/dist/media/"
          );
        }
      }

      logStdout("capture mode:", this.mode, this.isCaptureFinished);
      if (this.eyeType === "") {
        return;
      }

      if (this.mode === "fbut" && !this.currentShootingEye) this.currentShootingEye = this.eyeType;
      if (this.mode === "fbut" && this.currentShootingEye !== this.eyeType) {
        this.message(
          this.currentShootingEye === "OS"
            ? this.$t("langcfg.txtCurrentlyShotAsLeftEye")
            : this.$t("langcfg.txtCurrentShotIsRightEye"),
          "",
          "error"
        );
        return;
      }
      if (this.mode === "meibomian" || this.mode === "eyelidedge") {
        this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtProccessingData"));
      } else if (this.mode === "nibut" || this.mode === "fbut") {
        this.camera.setIsDrawNIBUTAndBUT(
          window.captureSettings.isDrawNIBUT,
          window.captureSettings.isDrawBUT
        );
      }
      if (!window.__capture__.debug && !this.isCameraReady) return;

      if (this.isPhoto()) {
        this.$bus.$emit(EVENTS.canLogout, false);

        if (!this.isCaptureFinished) return;
        this.isCaptureFinished = false;
        if (!this.isUpDown()) {
          this.$emit("show-waiting", this.$t("langcfg.txtProccessingData"), 50);
        }
        _imagePath = fileSys.getMediaPath(`${getSystemTime("", "_", "")}_${this.eyeType}.jpg`);
        this.camera.setProcessingData(true, 4);
        captureState = "doing";
        this.camera
          .takePhoto(_imagePath, this.mode === "meibomian" ? 2 : 0)
          .then(() => {
            // 拍摄图片

            if (this.isUpDown()) {
              this.previewSrc = `${_imagePath}?${Math.random()}`;
            }
            this.afterTakePhoto();
          })
          .catch((e) => {
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            this.message(this.$t("langcfg.txtFailToCapture"), "error");
          });
      }
      if (this.isVideo()) {
        // 拍摄视频

        if (
          !this.isCaptureFinished ||
          (this.isRecording && this.videoPhoto === "video" && this.recordSeconds < 2)
        ) {
          return;
        }
        this.$bus.$emit(EVENTS.canLogout, false);
        this.isRecording = this.videoPhoto === "video" ? !this.isRecording : false;
        clearInterval(timeVideoTip);
        if (this.isRecording) {
          // 开始拍摄
          this.isTakeVideo = true;
          this.isTakeVideoClose = true;
          // capture.closeWhiteLamp('pupilcorneadia_dynamic')
          let dirName = fileSys.getMediaPath(`${getSystemTime("", "_", "")}_${this.eyeType}`);
          _videoPath = `${dirName}_tmp.mp4`;
          _imagePath = `${dirName}.jpg`;
          this.videoPaths.push(_videoPath);
          this.imagePaths.push(_imagePath);
          const timeCheck = () => {
            this.isVideoTipVisible = !this.isVideoTipVisible;
            this.recordTime = getRecordTime(++this.recordSeconds);
            if (this.mode === "lipidlayer") {
              console.log(
                "window.captureSettings.lipidlayertime",
                window.captureSettings.lipidlayertime
              );
              if (this.recordSeconds > window.captureSettings.lipidlayertime) {
                this.takePhotoVideo();
              }
            }
            if (this.mode === "fbut") {
              if (this.recordSeconds > 20) {
                this.takePhotoVideo();
              }
            }
            if (this.mode === "nibut") {
              if (this.recordSeconds > 60) {
                this.takePhotoVideo();
              }
            }
            if (this.mode === "blink") {
              let time = window.captureSettings.BlinkTime
                ? Number(window.captureSettings.BlinkTime)
                : 60;
              if (this.recordSeconds > time) {
                this.takePhotoVideo();
              }
            }
            if (
              this.mode === "pupilcorneadia" &&
              this.pupilCorneaState === "pupilcorneadia_dynamic"
            ) {
              if (this.recordSeconds > 10) {
                this.takePhotoVideo();
                // capture.openWhiteLamp('pupilcorneadia_dynamic')
                return;
              }
              // if (this.recordSeconds === 2.6) {
              //   // 开启白光
              //   capture.openWhiteLamp("pupilcorneadia_dynamic");
              // }
              // if (this.recordSeconds === 4.6) {
              //   // 关闭白光
              //   capture.closeWhiteLamp("pupilcorneadia_dynamic");
              // }

              // let step = (this.maxValue / 10) * (this.interval / 1000);
              // this.pupilMax = this.pupilMax - step
              // capture.setDynamicpupil('pupilcorneadia_dynamicpupil', this.pupilMax)
              // setTimeout(() => {
              //   this.pupilMax = this.pupilMax - step
              //   capture.setDynamicpupil('pupilcorneadia_dynamicpupil', this.pupilMax)
              // }, this.interval);
            }
            if (captureState === "end") {
              this.camera.takeVideo(
                _videoPath,
                _imagePath,
                this.mode === "nibut",
                this.mode,
                nibutAutoStatus
              );
              // setTimeout(() => {
              //   capture.openWhiteLamp("pupilcorneadia_dynamic");
              // }, 1900);
              // setTimeout(() => {
              //   capture.closeWhiteLamp("pupilcorneadia_dynamic");
              // }, 3900);
            }
            captureState = "doing";
            this.isVideoTipVisible = false;
          };
          timeCheck();
          timeVideoTip = setInterval(timeCheck, 1000);
        } else {
          // 终止拍摄
          this.isTakeVideo = false;
          this.isTakeVideoClose = false;
          this.camera.setProcessingData(true, 5);
          this.isCaptureFinished = false;
          clearInterval(timeVideoTip);
          this.$emit("show-waiting", this.$t("langcfg.txtProccessingData"));
          if (this.mode === "fbut") {
            this.camera.setProcessingData(false, 6);
            let that = this;
            if (window.captureSettings.FBUTtime === 1) {
              this.camera
                .stopVideo(this.mode, nibutAutoStatus, this.recordTime)
                .then((nibutData) => {
                  that.currentBurArr.push(nibutData);
                  that.afterTakeVideo(that.currentBurArr);
                })
                .catch(() => {
                  let that = this;
                  that.recordSeconds = 0;
                  that.recordTime = "00:00";
                  that.currentBurArr = [];
                  that.currentNumberOfShots = 1;
                  this.camera.clearTempFiles(() => {
                    captureState = "end";
                    that.isCaptureFinished = true;
                    that.$emit("hide-waiting");
                  });
                  this.message(this.$t("langcfg.txtFailToCapture"), "error");
                });
            } else {
              this.camera
                .stopVideo(this.mode, nibutAutoStatus, this.recordTime)
                .then((nibutData) => {
                  if (that.currentNumberOfShots === 1) {
                    that.currentBurArr.push(nibutData);
                    that.recordSeconds = 0;
                    that.recordTime = "00:00";

                    that.isCaptureFinished = true;
                    that.$emit("hide-waiting");
                    that.currentNumberOfShots = 2;
                    // that.nibutAutoFn()
                  } else if (that.currentNumberOfShots === 2) {
                    that.currentBurArr.push(nibutData);
                    that.recordSeconds = 0;
                    that.recordTime = "00:00";

                    that.isCaptureFinished = true;
                    that.$emit("hide-waiting");
                    that.currentNumberOfShots = 3;
                    // that.nibutAutoFn()
                  } else {
                    that.currentBurArr.push(nibutData);
                    that.afterTakeVideo(that.currentBurArr);
                  }
                  captureState = "end";
                })
                .catch(() => {
                  let that = this;
                  that.recordSeconds = 0;
                  that.recordTime = "00:00";
                  that.currentBurArr = [];
                  that.currentNumberOfShots = 1;
                  this.camera.clearTempFiles(() => {
                    captureState = "end";
                    that.isCaptureFinished = true;
                    that.$emit("hide-waiting");
                  });
                  this.message(this.$t("langcfg.txtFailToCapture"), "error");
                });
            }
          } else if (this.mode === "blink") {
            // if (this.recordSeconds < 60) {
            //   capture.setProcessingData(false, 7)
            //   this.recordSeconds = 0
            //   this.recordTime = '00:00'
            //   capture.stopVideo(this.mode, nibutAutoStatus)
            //   capture.clearTempFiles(() => {
            //     console.log('delete file end')
            //     captureState = 'end'
            //     this.isCaptureFinished = true
            //     this.$emit('hide-waiting')
            //   })
            //   this.message(this.$t('langcfg.txtPleaseRecordVideo'), '', 'error')
            // } else {
            this.camera
              .stopVideo(this.mode, nibutAutoStatus, this.recordTime)
              .then((nibutData) => {
                this.afterTakeVideo(nibutData);
              })
              .catch(() => {
                let that = this;
                that.recordSeconds = 0;
                that.recordTime = "00:00";
                this.camera.clearTempFiles(() => {
                  captureState = "end";
                  that.isCaptureFinished = true;
                  that.$emit("hide-waiting");
                });
                this.notify(this.$t("langcfg.txtFailToCapture"), "", "error");
              });
            // }
          } else if (
            this.mode === "pupilcorneadia" &&
            this.pupilCorneaState === "pupilcorneadia_dynamic"
          ) {
            if (this.recordSeconds < 10) {
              this.camera.setProcessingData(false, 7);
              this.recordSeconds = 0;
              this.recordTime = "00:00";
              this.camera.stopVideo(this.mode, nibutAutoStatus);
              this.camera.clearTempFiles(() => {
                captureState = "end";
                this.isCaptureFinished = true;
                this.$emit("hide-waiting");
              });
              this.message(this.$t("langcfg.txtFailToCapture"), "error");
            } else {
              this.camera
                .stopVideo(this.mode, nibutAutoStatus, getRecordTime(10))
                .then((nibutData) => {
                  this.afterTakeVideo(nibutData);
                })
                .catch(() => {
                  let that = this;
                  that.recordSeconds = 0;
                  that.recordTime = "00:00";
                  this.camera.clearTempFiles(() => {
                    captureState = "end";
                    that.isCaptureFinished = true;
                    that.$emit("hide-waiting");
                  });
                  this.message(this.$t("langcfg.txtFailToCapture"), "error");
                });
            }
          } else {
            this.camera
              .stopVideo(this.mode, nibutAutoStatus, this.recordTime)
              .then((nibutData) => {
                this.afterTakeVideo(nibutData);
              })
              .catch(() => {
                let that = this;
                that.recordSeconds = 0;
                that.recordTime = "00:00";
                this.camera.clearTempFiles(() => {
                  captureState = "end";
                  that.isCaptureFinished = true;
                  that.$emit("hide-waiting");
                });
                this.message(this.$t("langcfg.txtFailToCapture"), "error");
              });
          }
        }
      }
    },
    zoomPreview(ev) {
      this.videoZoom *= ev.deltaY < 0 ? 1.05 : 0.95;
      this.videoZoom = this.videoZoom > 3 ? 3 : this.videoZoom;
      this.videoZoom = this.videoZoom < 1 ? 1 : this.videoZoom;
      if (this.checkType === PAGES.topography && this.mode !== "pupilcorneadia") {
        this.drawCT();
      } else {
        let x = (ev.offsetX / ev.target.clientWidth) * 2.0 - 1.0;
        let y = 1.0 - (ev.offsetY / ev.target.clientHeight) * 2.0;
        // this.drawDE(x, y, this.videoZoom)
        glRenderer.setZoom(x, y, this.videoZoom);
      }
    },
    drawCT() {
      let x = parseFloat(window.calibSettings.CenterPoint.x);
      let y = parseFloat(window.calibSettings.CenterPoint.y);
      this.centerPoint = { x, y };
      if (isDefined(previewIndicatrix)) {
        previewIndicatrix.drawCross(this.centerPoint.x, this.centerPoint.y, 1);
      }
      DrawCTCal.draw(
        canvasDraw,
        { xy: this.ctXYPos, z: this.ctZPos, offset: this.ctCaledOffset },
        window.ctShotInfo
      );
    },
    drawDE(x, y, zoom) {
      if (isDefined(previewIndicatrix)) {
        switch (this.mode) {
          case DRYEYEMODES.meibomian.key:
          case DRYEYEMODES.eyelidedge.key:
            previewIndicatrix.drawSemicircle(this.upDownInCapture);
            break;
          case "pupilcorneadia":
            let x = parseFloat(window.calibSettings.CenterPoint.x);
            let y = parseFloat(window.calibSettings.CenterPoint.y);
            this.centerPoint = { x, y };
            previewIndicatrix.clearDraw();
            previewIndicatrix.drawCross(this.centerPoint.x, this.centerPoint.y, 1);
            break;
          default:
            previewIndicatrix.clearDraw();
            break;
        }
      }
    },
    ctAutoShotChanged() {
      window.ctShotInfo.isAutoShot = this.ctAutoShot;
      saveShotInfo(window.ctShotInfo);
    },
    ctAutoUpDownChanged() {
      window.ctShotInfo.autoMove.updown = this.ctAutoUpDown;
      saveShotInfo(window.ctShotInfo);
    },
    nibutAutoFn() {
      // 0 表示NIBUT，1表示BUT
      // nibut情况
      if (this.mode === "nibut") {
        nibutAutoStatus = window.captureSettings.nibutModel ? 1 : 0;
        if (nibutAutoStatus === 1) {
          this.curNibutStatus = "focus";
          this.camera.clearAutoNibutData(this.mode);
          if (window.captureSettings.SelectLight) {
            this.camera.setAutoNibutParams(15, 0, nibutAutoStatus, 1.5, 1);
          } else {
            this.camera.setAutoNibutParams(15, 2, nibutAutoStatus, 1.5, 1);
          }
          if (isDefined(nibutInterval)) {
            clearInterval(nibutInterval);
          }
          nibutInterval = setInterval(() => {
            let res = this.camera.getAutoNibutData(this.mode);
            this.nibutAutoRecord(res);
          }, 1000);
        } else {
          if (isDefined(nibutInterval)) {
            clearInterval(nibutInterval);
          }
          nibutInterval = undefined;
          this.curNibutStatus = "Manualdefault";
          if (window.captureSettings.SelectLight) {
            this.camera.setAutoNibutParams(15, 0, nibutAutoStatus, 1.5, 0);
          } else {
            this.camera.setAutoNibutParams(15, 2, nibutAutoStatus, 1.5, 0);
          }
        }
        // but情况
      } else if (this.mode === "fbut") {
        nibutAutoStatus = window.captureSettings.BUTModel ? 1 : 0;

        if (nibutAutoStatus === 1) {
          this.curNibutStatus = "focus";
          this.camera.clearAutoNibutData(this.mode);
          this.camera.setAutoNibutParams(15, 1, nibutAutoStatus, 1.5, 1);
          if (isDefined(nibutInterval)) {
            clearInterval(nibutInterval);
          }
          nibutInterval = setInterval(() => {
            let res = this.camera.getAutoNibutData(this.mode);
            this.nibutAutoRecord(res);
          }, 1000);
        } else if (nibutAutoStatus === 0) {
          // 手动情况
          this.curNibutStatus = "Manualdefault";
          this.camera.clearAutoNibutData(this.mode);
          this.camera.setAutoNibutParams(15, 1, 1, 1.5, 1); // but的手动 自动入参一样1,1,1
          if (isDefined(nibutInterval)) {
            clearInterval(nibutInterval);
          }
          // nibutInterval = setInterval(() => {
          //   let res = capture.getAutoNibutData(this.mode)
          //   this.butManualRecord(res)
          // }, 1000)
        }
      }
    },
    // but手动拍摄
    butManualRecord(status) {
      if (!NIBUTSTATUS.focus.completed) {
        timeoutFocus = setTimeout(() => {
          if (status && status.but_status_good === 1) {
            this.curNibutStatus = "cantakePhoto";
            NIBUTSTATUS.focus.completed = true;
            this.camera.clearAutoNibutData(this.mode);
            // this.curNibutStatus = 'shootThreeTimes'
            // setTimeout(() => {
            this.clearNibutStatus();
            // }, 3000);
          } else {
            this.curNibutStatus = "focus";
          }
        }, 1000);
      }
    },
    // nibut fbut 自动拍摄
    nibutAutoRecord(status) {
      if (
        !NIBUTSTATUS.focus.completed &&
        !NIBUTSTATUS.firstBlinking.completed &&
        !NIBUTSTATUS.secondBlinking.completed
      ) {
        timeoutFocus = setTimeout(() => {
          if (status.nibut_status_good === 1 || status.but_status_good === 1) {
            NIBUTSTATUS.focus.completed = true;
            this.camera.clearAutoNibutData(this.mode);
            this.curNibutStatus = "firstBlinking";
            this.changeAudioSrcAndPlay();
          } else {
            // this.curNibutStatus = 'focus'
          }
        }, 1000);
      }
      if (
        !NIBUTSTATUS.firstBlinking.completed &&
        NIBUTSTATUS.focus.completed &&
        !NIBUTSTATUS.secondBlinking.completed
      ) {
        timeoutFirstBlink = setTimeout(() => {
          if (status.nibut_status_single === 1 || status.but_status_single === 1) {
            this.curNibutStatus = "SecondBlinking";
            this.camera.clearAutoNibutData(this.mode);
            NIBUTSTATUS.firstBlinking.completed = true;
            this.changeAudioSrcAndPlay();
          } else {
            if (intervalFirstBlink === undefined) {
              intervalFirstBlink = setInterval(() => {
                this.changeAudioSrcAndPlay();
              }, 5000);
            }
          }
        }, 1000);
      }
      if (
        NIBUTSTATUS.focus.completed &&
        NIBUTSTATUS.firstBlinking.completed &&
        !NIBUTSTATUS.secondBlinking.completed
      ) {
        clearInterval(intervalFirstBlink);
        intervalFirstBlink = undefined;
        timeoutSecondBlink = setTimeout(() => {
          if (status.nibut_status_single === 1 || status.but_status_single === 1) {
            this.camera.clearAutoNibutData(this.mode);
            NIBUTSTATUS.secondBlinking.completed = true;
            this.curNibutStatus = "startCam";
            setTimeout(() => {
              this.takePhotoVideo();
            }, 500);
          } else {
            if (intervalSecondBlink === undefined) {
              intervalSecondBlink = setInterval(() => {
                this.changeAudioSrcAndPlay();
              }, 5000);
            }
          }
        }, 1000);
      }
      if (this.curNibutStatus === "startCam") {
        clearInterval(intervalSecondBlink);
        intervalSecondBlink = undefined;
        this.changeAudioSrcAndPlay();
        setTimeout(() => {
          this.curNibutStatus = "keep";
        }, 2000);
      }
      if (
        this.curNibutStatus === "keep" &&
        NIBUTSTATUS.firstBlinking.completed &&
        NIBUTSTATUS.secondBlinking.completed
      ) {
        clearInterval(intervalSecondBlink);
        intervalSecondBlink = undefined;
        timeoutKeepBlink = setTimeout(() => {
          if (
            (this.recordSeconds > 5 &&
              (status.nibut_status_single === 1 || this.recordSeconds > 19)) ||
            (this.recordSeconds > 5 && (status.but_status_single === 1 || this.recordSeconds > 19))
          ) {
            this.camera.clearAutoNibutData(this.mode);
            this.clearNibutStatus();
            this.curNibutStatus = "end";
            this.changeAudioSrcAndPlay();
            setTimeout(() => {
              this.takePhotoVideo();
            }, 500);
          } else {
            if (intervalkeep === undefined) {
              intervalkeep = setInterval(() => {
                // 循环语音播报请保持睁眼
                this.changeAudioSrcAndPlay();
              }, 5000);
            }
          }
        }, 1000);
      }
    },
    clearNibutStatus() {
      this.camera.setAutoNibutParams(15, 0, nibutAutoStatus, 1.5, 0);
      clearTimeout(timeoutFocus);
      clearTimeout(timeoutFirstBlink);
      clearTimeout(timeoutSecondBlink);
      clearTimeout(timeoutKeepBlink);

      clearInterval(nibutInterval);
      clearInterval(intervalFirstBlink);
      clearInterval(intervalSecondBlink);
      clearInterval(intervalkeep);
      clearInterval(IntervalButManual);
      intervalkeep = undefined;
      nibutInterval = undefined;
      intervalFirstBlink = undefined;
      intervalSecondBlink = undefined;
      IntervalButManual = undefined;
      NIBUTSTATUS.focus.completed = false;
      NIBUTSTATUS.firstBlinking.completed = false;
      NIBUTSTATUS.secondBlinking.completed = false;
    },
    // nibut音频播放
    changeAudioSrcAndPlay(params) {
      if (isDefined(params)) {
        saveAudioSrc = params;
      }
      this.audioSrc = saveAudioSrc;
      setTimeout(() => {
        this.$refs.audioRef.play();
      }, 500);
    },
    updateEyeMaterial() {
      this.currEyeType = window.captureSettings.EyeMaterial;
    }
  },
  props: {
    upDown: {
      type: String,
      default: "up_down"
    },
    pupilCornea: {
      type: String,
      default: "pupil"
    },
    currentRecord: {
      type: Object
    },
    checkType: {
      type: String,
      default: "topography"
    },
    mode: {
      type: String,
      default: ""
    },
    forupDownInCaptrue: {
      type: String,
      default: ""
    },
    focusLanguage: {
      type: String,
      default: ""
    },
    currentPupilCornea: {
      type: String,
      default: ""
    }
  },
  watch: {
    focusLanguage(val) {
      if (this.mode === "nibut") intervalFirstBlink = undefined;
      if (val === "zh_CN") {
        this.willChangeTips = true;
      } else if (val === "en_US") {
        this.willChangeTips = false;
      }
    },
    checkType: function () {},
    mode: function (val) {
      this.mediaFiles = {};
      this.setCaptureMode();
      if (this.checkType === PAGES.dryeye) {
        this.drawDE();
      }
      if (this.mode === "fbut" || this.mode === "ocularsurface") {
        this.camera.startBuleLight();
      } else {
        this.camera.closeBuleLight();
      }
      if (this.mode === "pupilcorneadia") {
        previewIndicatrix.clearDraw();
        previewIndicatrix.drawCross(this.centerPoint.x, this.centerPoint.y, 1);
        this.camera.stopUpDown();
      } else if (this.mode === "nibut" || this.mode === "fbut") {
        this.nibutAutoFn();
      } else {
        this.clearNibutStatus();
      }
      if (this.mode !== "fbut") {
        this.currentNumberOfShots = 1;
      }
    },
    upDownInCapture: function (newValue) {
      previewIndicatrix.clearDraw();
      this.drawDE();
    },
    butModelComputed(val) {
      this.nibutAutoFn();
    },
    nibutModelComputed(val) {
      this.nibutAutoFn();
    }
  },
  beforeDestroy() {
    window.pupilCorneaState = null;
    window.topographyState = null;
    document.removeEventListener("keydown", this.onkeydown);
    glRenderer.deleteGL();
    glRenderer.glCtx = undefined;
    this.camera.closeBuleLight();
    this.camera.closeAllLamps(() => {
      this.camera.stopUpDown();
    });
    this.eyeType = "";
    clearTimeout(_timeoutFrame);
    clearTimeout(timeoutCloseLamps);
    clearInterval(timeVideoTip);
    this.$bus.$off(EVENTS.eyeTypeShot);
    this.$bus.$off(EVENTS.changeEyeMaterial);
    // nibut自动拍摄销毁操作
    this.clearNibutStatus();
    this.camera.off("frame-callback");
    // 退出拍摄界面,关闭所有灯光
  }
};
</script>
<style lang="less" scoped>
.warningClass {
  z-index: 998;
  position: fixed;
  //bottom:30px;
  // /副屏统计
  bottom: 165px;
  left: 40%;
  color: rgb(176, 241, 159);
  font-size: 30px;
  transform: translateX(-50%);
  span {
    color: rgb(176, 241, 159);
  }
}
.numofshotsClass {
  z-index: 998;
  position: fixed;
  //bottom:30px;
  // /副屏统计
  bottom: 165px;
  left: 65%;
  color: rgb(176, 241, 159);
  font-size: 30px;
  transform: translateX(-50%);
  span {
    color: rgb(176, 241, 159);
  }
}
.el-button {
  width: 90%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: @header-fs+30px;
  }
}
.btn-oprator {
  height: @header-fs+110px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}

.pupil-btn {
  height: 40px;
  margin: 8px 0 8px 0;
}

.pupilType-highlight {
  // background-color: rgba(0, 255, 0, 0.637);
  border: 3px solid #409eff;
  // span {
  //   color: #409eff;
  // }
}

.pupilType-complete {
  background-color: rgba(0, 255, 0, 0.637);
}

.pupil-complete-N::after {
  content: " ○";
  color: white;
}

.pupil-complete-Y::after {
  content: " ●";
  color: white;
}

.btn-oprator:active {
  background: @btn-active-color;
}
.eyetype-symbol {
  position: absolute;
  color: #f80;
  font-size: @header-fs;
  z-index: 999;
  i {
    font-size: 40px;
  }
}
.cam-window {
  border: "none";
  position: absolute;
}
.black {
  background: "#000";
}
.capture-aside {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.aside-content {
  width: 100%;
}
.color-normal {
  color: white;
}
.color-recording {
  color: red;
}
.border-normal :hover {
  i {
    color: @btn-hover-color;
  }
}
.border-recording {
  border: 1px solid red;
}
.border-recording:hover {
  i {
    color: red;
  }
}
.video-mask {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
}
.el-radio {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
/deep/ .el-form-item__content {
  display: flex !important;
}
/deep/ .el-icon-lock {
  position: relative !important;
  right: 22px !important;
}
.form-text {
  font-size: 30px;
  color: white;
}
.split {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
</style>
<style lang="less">
#capture {
  .el-checkbox .el-checkbox__label {
    font-size: 28px;
    vertical-align: middle;
  }
  .el-checkbox__inner {
    width: 30px;
    height: 30px;
  }
  .el-checkbox__inner::after {
    width: 12px;
    height: 25px;
    left: 8px;
    top: -5px;
  }
  .el-tabs--border-card {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #3da13d;
    background-color: transparent;
    border-right-color: rgba(0, 255, 0, 0.4);
    border-left-color: rgba(0, 255, 0, 0.4);
  }
  .el-tabs--border-card > .el-tabs__header {
    background-color: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0;
  }
  .el-tabs__item:hover {
    color: #3da13d;
  }
  .el-tabs__item {
    color: white;
    font-size: 23px;
  }
  .el-input__inner {
    font-size: 23px;
    line-height: 50px;
    background-color: #fff;
    height: 50px;
  }
  .btn-z-index {
    z-index: 110;
  }
  .div-moduleeye {
    font-size: 20px;
    color: gray;
    text-align: center;
    margin-top: -80px;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/Capture.vue